import { fitReasons } from '../content/site'
import { Reveal } from './Reveal'
import { SectionLabel } from './SectionLabel'

export function WhyKcc() {
  return (
    <section className="section fit-section" id="fit">
      <div className="shell fit-head">
        <SectionLabel number="05" label="Why KCC" />
        <Reveal>
          <p className="section-kicker">Retail fit</p>
          <h2>A practical category for everyday mall traffic.</h2>
        </Reveal>
      </div>
      <div className="shell fit-list">
        {fitReasons.map((reason, index) => (
          <Reveal className="fit-row" key={reason.number} delay={Math.min(index * 0.035, 0.12)}>
            <span className="fit-number">{reason.number}</span>
            <h3>{reason.title}</h3>
            <p>{reason.body}</p>
          </Reveal>
        ))}
      </div>
    </section>
  )
}
